(function () {
  if (typeof document === 'undefined') return;
  // Defensive: this file was previously loaded twice (one regular <script> in
  // theme.liquid + one type=module load in snippets/scripts.liquid), which
  // registered two `click` listeners and caused every quick-add click to fire
  // /cart/add twice. The duplicate <script> tag has been removed; this guard
  // ensures even if it comes back, the listener is only registered once.
  if (window.__bwQuickAddInit) return;
  window.__bwQuickAddInit = true;
  const routes = (window.theme && window.theme.routes) || {};
  const addUrl = routes.cart_add_url || '/cart/add';
  const cartUrl = routes.cart_url || '/cart';
  function flashSuccess(btn) {
    const label = btn.querySelector('.quick-add__label');
    const ok = btn.querySelector('.quick-add__success');
    if (label && ok) { label.hidden = true; ok.hidden = false; btn.classList.add('is-added'); setTimeout(() => { label.hidden = false; ok.hidden = true; btn.classList.remove('is-added'); }, 1500); }
    else { btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1500); }
  }
  async function updateCount() {
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const data = await r.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = data.item_count; });
    } catch (_) {}
  }
  async function add(variantId, qty, btn) {
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }) });
      if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.description || 'Unable to add'); }
      flashSuccess(btn); updateCount();
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (e) { console.warn('[quick-add]', e.message); btn.classList.add('is-error'); setTimeout(() => btn.classList.remove('is-error'), 1500); }
    finally { btn.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) { window.location.href = cartUrl; return; }
    add(variantId, 1, btn);
  });
  try {
    const key = 'bw_wishlist';
    const list = new Set(JSON.parse(localStorage.getItem(key) || '[]'));
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const card = btn.closest('[data-product-id]');
      const id = card && card.getAttribute('data-product-id');
      if (id && list.has(id)) btn.setAttribute('aria-pressed', 'true');
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (!id) return;
        if (list.has(id)) { list.delete(id); btn.setAttribute('aria-pressed', 'false'); } else { list.add(id); btn.setAttribute('aria-pressed', 'true'); }
        localStorage.setItem(key, JSON.stringify([...list]));
      });
    });
  } catch (_) {}
})();